export default (editor) => {
  const {
    value: { fragment },
  } = editor;

  if (fragment) {
    const fragmentNodes = fragment.nodes.toArray();

    const anchorFragment = fragmentNodes[0];

    if (anchorFragment && anchorFragment.nodes) {
      const childNodes = anchorFragment.nodes.toArray();

      if (childNodes && childNodes.length > 1) {
        editor.moveToFocus();
        return true;
      }
    }
  }

  return false;
};
